import axios from "axios"

import { API_URL } from "../../config/appConfig"

export const PRODUCT_URL = `${API_URL}/api/Product`

export const getProductSymbol = (issuerId: string, partial: string) => {
  return axios({
    method: "post",
    url: `${PRODUCT_URL}/symbol/${issuerId}?partial=${partial}`,
  })
}

// TO DO: change this to .get and .post
// -1 is default and will give all the Products
export const getListOfProducts = (issuerId = "-1", headers: any) => {
  return axios.get(`${PRODUCT_URL}/issuer/${issuerId}`, { headers })
}

export const getListOfPendingProducts = (headers: any) => {
  return axios.get(`${PRODUCT_URL}/pending`, { headers })
}

export const submitProduct = (payload: any) => {
  return axios({
    method: "post",
    url: `${PRODUCT_URL}`,
    data: payload,
  })
}

export const searchProduct = (payload: string) => {
  return axios({
    method: "get",
    url: `${PRODUCT_URL}/search`,
    params: {
      value: payload
    },
  })
}

export const editProduct = (payload: any) => {
  return axios({
    method: "put",
    url: `${PRODUCT_URL}/update`,
    data: payload
  })
}

export const getProduct = (productId: number) => {
  return axios.get(`${PRODUCT_URL}/${productId}`)
}

export const delProduct = (productId: any) => {
  return axios({
    method: "delete",
    url: `${PRODUCT_URL}/${productId}`
  })
}

export const modifyProduct = (productId: number, status: string) => {
  return axios({
    method: "patch",
    url: `${PRODUCT_URL}/${productId}?status=${status}`
  })
}

export const getLiveInstrumentsByProductID = (productId: number) => {
  return axios.get(`${PRODUCT_URL}/${productId}/live-instruments`)
}

export const getDeletedInstrumentsByProductID = (productId: number) => {
  return axios.get(`${PRODUCT_URL}/${productId}/deleted-instruments`)
}

export const getStageInstrumentsByProductID = (productId: number) => {
  return axios.get(`${PRODUCT_URL}/${productId}/stage-instruments`)
}

export const productSearch = (payload: any, headers: any) => {
  return axios.post(`${PRODUCT_URL}/ProductSearch`, payload, { headers })
}